import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

type Props = {
    notLogged?: boolean;
};

const GoToLogin = (props: Props) => {
    const navigate = useNavigate();
    useEffect(()=>{
        navigate('/Login');
    }, [])

    return (
        <></>
    )
}


export default GoToLogin;